import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4fb1b08d&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=4fb1b08d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb1b08d",
  null
  
)

export default component.exports